import { connect } from 'react-redux';
import { reportBreakdownEvent, TYPES } from '../../../../../../utils/reports/breakdown';
import { toggleSelectedStars } from '../../../../../../store/actions';
import StarsCounter from './StarsCounter';

const mapStateToProps = ({ selectedStars = [] }, props) => {
    const { value } = props;

    return {
        selected: selectedStars.includes(value),
    };
};

const mapDispatchToProps = (dispatch, { value }) => ({
    onToggle: (selected) =>
        dispatch(toggleSelectedStars(value)).then((eventData) => {
            const type = selected ? TYPES.ratingsBreakdownClearClick : TYPES.ratingsBreakdownClick;

            reportBreakdownEvent(type, { ...eventData, text: value });
        }),
});

export default connect(mapStateToProps, mapDispatchToProps)(StarsCounter);
